// Some paths act as intermediate paths. For example, going to
// "/teacher/class/CLASS_ID" will redirect to a Class Dashboard tab.
const isIntermediatePath = (pathname: string): boolean => {
    // The Class Dashboard path may contain a trailing slash; all Class
    // Dashboard paths that we will consider as intermediate paths will
    // start with "/teacher/class/" followed by "CLASS_ID" or "CLASS_ID/".
    const pathParts = pathname.split("/");
    const isClassDashboardPathBeginning =
        pathname.startsWith("/teacher/class/");
    const classDashboardPathHasNoPage =
        pathParts.length === 4 ||
        (pathParts.length === 5 && pathParts[4] === "");

    return isClassDashboardPathBeginning && classDashboardPathHasNoPage;
};

export default isIntermediatePath;
